/** Whether a run exercises the flow for real or as a test. */
export var FlowRunType;
(function (FlowRunType) {
    FlowRunType["Test"] = "test";
    FlowRunType["Production"] = "production";
})(FlowRunType || (FlowRunType = {}));
//# sourceMappingURL=runType.js.map